import { render, staticRenderFns } from "./CargoValue.vue?vue&type=template&id=65e4185a&scoped=true"
import script from "./CargoValue.vue?vue&type=script&lang=js"
export * from "./CargoValue.vue?vue&type=script&lang=js"
import style0 from "./CargoValue.vue?vue&type=style&index=0&id=65e4185a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4185a",
  null
  
)

export default component.exports